import React from 'react'
import "./cardDataInfo.scss";

const CardDataInfo = ({ className = '', children }) => {
    return (
        <div className={`card-datainfo ${className}`}>{children}</div>
    )
}

export default CardDataInfo